import Swiper from 'swiper';
import { Navigation, A11y, EffectCoverflow } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/effect-coverflow';
import './journey-steps.scss';

class JourneySteps {
    constructor ($element, options) {
        const defaults = {
            initAttr: 'data-journey-steps',
            sliderAttr: 'main',
            slideAttr: 'slide'
        };

        this.settings = Object.assign({}, defaults, options);
        this.$root = $element;
        this.$container = this.$root.querySelector(`[${this.settings.initAttr}="${this.settings.sliderAttr}"]`);
        this.$slides = this.$root.querySelectorAll(`[${this.settings.initAttr}="${this.settings.slideAttr}"]`);
        this.$prevBTN = this.$container.querySelector('[data-swiper-prev]');
        this.$nextBTN = this.$container.querySelector('[data-swiper-next]');
        this.slider = null;

        if (this.$container && this.$slides.length > 1) {
            this.initialize();
        }
    }

    initialize () {
        this.initSlider();
    }

    initSlider () {
        this.slider = new Swiper(this.$container, {
            modules: [Navigation, A11y, EffectCoverflow],
            speed: 650,
            effect: 'coverflow',
            grabCursor: true,
            centeredSlides: true,
            slidesPerView: 'auto',
            spaceBetween: 16,
            coverflowEffect: {
                rotate: 0,
                stretch: 20,
                depth: 200,
                modifier: 1.1,
                scale: 0.9,
                slideShadows: false
            },
            navigation: {
                prevEl: this.$prevBTN,
                nextEl: this.$nextBTN,
                addIcons: false,
            },
            breakpoints: {
                768: {
                    spaceBetween: 0
                }
            }
        });
    }
}

export { JourneySteps };

window.addEventListener('content.loaded', (e) => {
    const $context =  e.detail.$context;

    if ($context) {
        const $$JourneySteps = $context.querySelectorAll('[data-journey-steps="root"]');

        for (let i = 0; i < $$JourneySteps.length; i++) {
            const $JourneySteps = $$JourneySteps[i];

            const JourneyStepsAPI = new JourneySteps($JourneySteps);
            $JourneySteps.API = JourneyStepsAPI;
        }
    }
});
